import React from 'react';
import { createRoot } from 'react-dom/client';

import { TheoryAccessSellingPage } from '../main-app/components/TheoryAccessSellingPage';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-theory-access-selling-page');
  const schoolName = node.getAttribute('data-school-name');
  const schoolPhone = node.getAttribute('data-school-phone');
  const schoolId = node.getAttribute('data-school-id');
  const cost = node.getAttribute('data-cost');

  const root = createRoot(node);
  root.render(
    <TheoryAccessSellingPage schoolName={schoolName} schoolPhone={schoolPhone} schoolId={schoolId} cost={cost} />,
  );
});
